import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import { NewPlanEditPresenter } from "./presenter";
import { usePlanEditQuery } from "../../model/repository/new";

type Props = {
	hotelID: string;
	planID: string | undefined;
	activeLangCode: LangCode;
};

export const NewPlanEditContainer = ({ hotelID, planID, activeLangCode }: Props) => {
	const serverModel = usePlanEditQuery({ hotelID, planID });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.PLAN.TOP, { hotelID })} />;
	}

	return (
		<NewPlanEditPresenter
			serverModel={serverModel}
			activeLangCode={activeLangCode}
			hotelID={hotelID}
			planID={planID}
		/>
	);
};

NewPlanEditContainer.displayName = "NewPlanEditContainer";
